import * as React from 'react';

import styles from './divider.module.css';

type Props = {
    text?: string;
    darkText?: boolean;
    isDisabled?: boolean;
};

export class Line extends React.PureComponent<Props> {
    render() {
        return (
            <div
                className={this.props.isDisabled ? styles['container--disabled'] : styles.container}
            >
                <div className={styles['divider-line']} />
                {this.props.text ? (
                    <div
                        className={
                            this.props.darkText
                                ? styles['divider-text--dark']
                                : styles['divider-text']
                        }
                    >
                        {this.props.text}
                    </div>
                ) : undefined}
                <div className={styles['divider-line']} />
            </div>
        );
    }
}
